<template>
  <div class="collection-orders-container">
    <div class="page-header">
      <el-button 
        type="text" 
        icon="el-icon-arrow-left" 
        @click="$router.go(-1)"
        class="back-button"
      >
        Back
      </el-button>
      <h2>Collection Orders</h2>
      <div v-if="collectionInfo" class="collection-info">
        <h3>{{ collectionInfo.title }}</h3>
        <p class="collection-description">{{ collectionInfo.description }}</p>
      </div>
    </div>

    <div class="orders-content">
      <el-table
        v-if="!loading && orders.length"
        :data="orders"
        stripe
        style="width: 100%; margin-top: 20px;"
      >
        <el-table-column label="Order ID" width="250">
          <template #default="scope">
            {{ scope.row._id?.$oid || scope.row._id?.$id || scope.row._id || scope.row.order_id }}
          </template>
        </el-table-column>
        <el-table-column prop="user_nickName" label="User" width="150" />
        <el-table-column prop="status" label="Status" width="120">
          <template #default="scope">
            <el-tag :type="statusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="Ordered At" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="usd_price" label="Price" width="120">
          <template #default="scope">
            ${{ scope.row.usd_price || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="Action" width="120">
          <template #default="scope">
            <el-button size="mini" @click="viewOrder(scope.row)">View</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-empty 
        v-else-if="!loading && !orders.length" 
        description="No orders found for this course." 
      />
      
      <el-skeleton v-else :rows="4" animated />
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front'

export default {
  name: 'CollectionOrderList',
  data() {
    return {
      collectionId: null,
      collectionInfo: null,
      orders: [],
      loading: false
    }
  },
  mounted() {
    this.collectionId = this.$route.query.collection_id
    if (this.collectionId) {
      this.fetchCollectionInfo()
      this.fetchCollectionOrders()
    } else {
      this.$message.error('Collection ID is required')
      this.$router.go(-1)
    }
  },
  methods: {
    async fetchCollectionInfo() {
      try {
        const response = await postRequest('getCollection', {
          collection_id: this.collectionId,
          user_id: this.$store.state.user_id
        })
        if (response.data.code === 0) {
          this.collectionInfo = response.data.data
        }
      } catch (error) {
        console.error('Failed to fetch collection info:', error)
      }
    },
    
    async fetchCollectionOrders() {
      this.loading = true
      try {
        const response = await postRequest('getCreatorCollectionOrders', {
          collection_id: this.collectionId,
          user_id: this.$store.state.user_id
        })
        if (response.data.code === 0) {
          this.orders = response.data.data || []
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch collection orders')
        }
      } catch (error) {
        this.$message.error('Failed to fetch collection orders')
        console.error('Error fetching collection orders:', error)
      } finally {
        this.loading = false
      }
    },
    
    formatDate(date) {
      if (!date) return ''
      return new Date(date * 1000).toLocaleString()
    },
    
    statusType(status) {
      switch (status) {
        case 'COMPLETE': return 'success'
        case 'PENDING': return 'warning'
        case 'CANCELLED': return 'info'
        case 'FAILED': return 'danger'
        default: return ''
      }
    },
    
    viewOrder(order) {
      this.$router.push({
        path: '/collection-order',
        query: { order_id: order.order_id }
      })
    }
  }
}
</script>

<style scoped>
.collection-orders-container {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
  margin: 20px;
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.back-button {
  color: #606266;
  font-size: 14px;
}

.back-button:hover {
  color: #409EFF;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
  font-weight: 600;
}

.collection-info {
  margin-left: auto;
  text-align: right;
}

.collection-info h3 {
  margin: 0 0 4px 0;
  color: #303133;
  font-size: 18px;
  font-weight: 500;
}

.collection-description {
  margin: 0;
  color: #909399;
  font-size: 14px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.orders-content {
  margin-top: 20px;
}

.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 500;
}

.el-table td {
  padding: 12px 0;
}

.el-tag {
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 8px;
}

.el-button--mini {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 4px;
}
</style> 